import axios from "../../axios";
import {
  DRIVER_ADD_SUCCESS,
  DRIVER_ADD_REQUEST,
  DRIVER_ADD_FAIL,
  //
  DRIVER_LIST_SUCCESS,
  DRIVER_LIST_REQUEST,
  DRIVER_LIST_FAIL,
  //
  DRIVER_DETAIL_SUCCESS,
  DRIVER_DETAIL_REQUEST,
  DRIVER_DETAIL_FAIL,
  //
  DRIVER_DELETE_SUCCESS,
  DRIVER_DELETE_REQUEST,
  DRIVER_DELETE_FAIL,
  //
  DRIVER_UPDATE_SUCCESS,
  DRIVER_UPDATE_REQUEST,
  DRIVER_UPDATE_FAIL,
  //

  //
} from "../constants/driverConstants";

// delete driver
export const deleteDriver = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DRIVER_DELETE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.delete(`users/drivers/delete/${id}/`, config);

    dispatch({
      type: DRIVER_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: DRIVER_DELETE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "Votre profile n'a pas été modifié, réessayez",
    });
  }
};

// create category
export const updateDriver = (id, driver) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DRIVER_UPDATE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.put(
      `/users/drivers/update/${id}/`,
      driver,
      config
    );

    dispatch({
      type: DRIVER_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: DRIVER_UPDATE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// get category detail
export const getDriverDetail = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DRIVER_DETAIL_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.get(`/users/drivers/detail/${id}/`, config);

    dispatch({
      type: DRIVER_DETAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (err === "Given token not valid for any token type") {
        localStorage.removeItem("userInfoUnimedCare");
        document.location.href = "/";
      }
    }
    dispatch({
      type: DRIVER_DETAIL_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};

// create category
export const addNewDriver = (driver) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DRIVER_ADD_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.post(`/users/drivers/create/`, driver, config);

    dispatch({
      type: DRIVER_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: DRIVER_ADD_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// get all organizers
export const getListDrivers = (page) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DRIVER_LIST_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.get(`/users/drivers/?page=${page}`, config);

    dispatch({
      type: DRIVER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: DRIVER_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};
